import React, { useState, useEffect, useRef } from 'react';
import cn from 'classnames';
import { Button, BUTTON_TYPES } from '_atoms';
import type { RichTextProps } from './types';
import { sanitizeRichTextHtml } from './utils';
import './style.scss';

export const RichText: React.FC<RichTextProps> = ({ text, className, opened }) => {
  const [open, setOpen] = useState(opened);
  const [height, setHeight] = useState(0);
  const ref = useRef<HTMLDivElement>(null);

  const onLoadMore = () => setOpen(o => !o);

  useEffect(() => {
    if (ref.current) setHeight(ref.current.scrollHeight);
  });

  return (
    <div className={cn('rich-area-default__rich-content rich-text__wrapper', className)}>
      <div
        ref={ref}
        className={cn('rich-text', { open })}
        // The HTML is sanitized immediately before reaching this rendering sink.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: sanitizeRichTextHtml(text ?? ''),
        }}
      />
      {!opened && height > 110 && (
        <Button onClick={onLoadMore} type={BUTTON_TYPES.TEXT}>
          {open ? 'Show less' : 'Show more'}
        </Button>
      )}
    </div>
  );
};
